module.exports = __webpack_public_path__ + "img/de.d810f621.svg";